import React, { Component, PropTypes } from 'react';

export default class PrimaryButton extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        loadingName: PropTypes.string.isRequired,
        onClickEvent: PropTypes.func,
        type: PropTypes.string.isRequired,
        icon: PropTypes.string
    };

    handleClick = () => {
        if (this.props.onClickEvent) {
            this.props.onClickEvent();
        }
    };

    render() {
        if (this.props.isLoading) {
            return (
                <button type={this.props.type} className="btn btn-lg btn-circle green-meadow disabled col-md-8 col-lg-8 col-sm-12 col-xs-12" disabled>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"/> &nbsp;
                    {this.props.loadingName}
                </button>
            )
        }

        return (
            <button type={this.props.type} className="btn btn-circle btn-lg green-meadow col-md-8 col-lg-8 col-sm-12 col-xs-12"
                    onClick={this.handleClick}>
                {this.props.name}
            </button>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Buttons/PrimaryButton.js
 **/